export default "__VITE_ASSET__BAmL$5Fp__"